module.exports = __webpack_public_path__ + "img/beianicon.d0289dc0.png";